var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonitoring01 = function SvgMonitoring01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.01,
    y1: 167.76,
    x2: 176.01,
    y2: 12.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3.92,
    y1: 161.11,
    x2: 170.08,
    y2: 6.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 16.03,
    y1: 183.51,
    x2: 190.03,
    y2: 28.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 10.41,
    y1: 177.2,
    x2: 184.41,
    y2: 22.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2.12,
    y1: 163.13,
    x2: 171.88,
    y2: 8.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 34.04,
    y1: 203.72,
    x2: 208.04,
    y2: 48.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 25.34,
    y1: 193.96,
    x2: 199.34,
    y2: 38.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 16.65,
    y1: 184.2,
    x2: 190.65,
    y2: 29.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 28.74,
    y1: 197.77,
    x2: 202.74,
    y2: 42.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 41.96,
    y1: 212.62,
    x2: 215.96,
    y2: 57.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -32.14,
    y1: 129.43,
    x2: 141.86,
    y2: -25.57,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M180.47,8.22h-62.89c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h62.89c6.69,0,12.12,5.44,12.12,12.12v89.95h-77.84c6.85-8.13,10.99-18.62,10.99-30.05,0-25.77-20.96-46.73-46.73-46.73s-46.73,20.96-46.73,46.73c0,7.8,1.93,15.14,5.32,21.61l-8.74,8.74H7.41V27.34c0-6.69,5.44-12.12,12.12-12.12h62.89c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5H19.53C8.99,8.22.41,16.8.41,27.34v106.25c0,3.49.99,6.93,2.78,9.9-4.08,5.48-3.65,13.28,1.32,18.25,2.73,2.73,6.31,4.09,9.9,4.09s7.17-1.36,9.9-4.09l9.02-9.02h38.47l-3.85,14.88h-4.66c-6.67,0-12.09,5.42-12.09,12.09s5.43,12.09,12.09,12.09h73.44c6.67,0,12.09-5.42,12.09-12.09s-5.42-12.09-12.09-12.09h-4.66l-3.85-14.88h52.27c10.55,0,19.12-8.58,19.12-19.12V27.34c0-10.55-8.58-19.12-19.12-19.12ZM79,47.51c21.91,0,39.73,17.82,39.73,39.73s-17.82,39.73-39.73,39.73-39.73-17.82-39.73-39.73,17.82-39.73,39.73-39.73ZM21.85,124.59l-13.56,13.56c-.58-1.43-.89-2.96-.89-4.56v-9h14.45ZM19.35,156.79c-2.73,2.73-7.17,2.73-9.9,0-2.73-2.73-2.73-7.17,0-9.9l23.32-23.32h0s8.62-8.63,8.62-8.63c2.79,3.77,6.13,7.11,9.9,9.9l-21.9,21.9h0s-10.04,10.05-10.04,10.05ZM141.81,179.69c0,2.81-2.29,5.09-5.09,5.09H63.28c-2.81,0-5.09-2.29-5.09-5.09s2.29-5.09,5.09-5.09h73.44c2.81,0,5.09,2.29,5.09,5.09ZM124.82,167.59h-49.65l3.85-14.88h41.95l3.85,14.88ZM180.47,145.72H40.32l17.07-17.07c6.47,3.39,13.82,5.32,21.61,5.32,10.69,0,20.54-3.61,28.42-9.67h85.17v9.3c0,6.69-5.44,12.12-12.12,12.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79,107.28c12.8,0,24.43-7.06,30.36-18.42.53-1.01.53-2.22,0-3.24-5.93-11.36-17.56-18.42-30.36-18.42s-24.43,7.06-30.36,18.42c-.53,1.01-.53,2.22,0,3.24,5.93,11.36,17.56,18.42,30.36,18.42ZM79,80.45c3.74,0,6.79,3.04,6.79,6.79s-3.04,6.79-6.79,6.79-6.79-3.04-6.79-6.79,3.04-6.79,6.79-6.79ZM102.24,87.24c-3.85,6.31-10.03,10.7-17.1,12.33,4.53-2.26,7.65-6.93,7.65-12.33s-3.12-10.06-7.65-12.33c7.07,1.63,13.24,6.02,17.1,12.33ZM72.87,74.91c-4.53,2.26-7.65,6.93-7.65,12.33s3.12,10.06,7.65,12.33c-7.07-1.63-13.24-6.02-17.1-12.33,3.85-6.31,10.03-10.7,17.1-12.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.11,55.92c0,1.93,1.57,3.5,3.5,3.5h39.3c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5h-39.3c-1.93,0-3.5,1.57-3.5,3.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.91,40.67c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5h-22.61c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h22.61Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M142.51,35.83c-.09-.21-.2-.41-.32-.6-.13-.19-.28-.37-.44-.53-.16-.17-.34-.31-.53-.44-.19-.13-.39-.23-.6-.32-.21-.09-.43-.16-.66-.2-.45-.09-.91-.09-1.36,0-.23.04-.45.11-.66.2-.21.09-.41.19-.6.32s-.37.27-.53.44c-.66.64-1.03,1.55-1.03,2.47,0,.23.02.46.07.69.04.22.11.44.2.65.08.21.19.41.32.6.13.2.27.37.44.54.16.16.34.3.53.43.19.13.39.24.6.32.21.09.43.16.66.2.22.05.45.07.68.07s.46-.02.68-.07c.23-.04.45-.11.66-.2.21-.08.41-.19.6-.32.19-.13.37-.27.53-.43.65-.66,1.03-1.56,1.03-2.48,0-.23-.02-.46-.07-.68-.04-.23-.11-.45-.2-.66Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M182.14,73.33c-.09-.21-.2-.41-.32-.6-.13-.19-.28-.37-.44-.54-.81-.81-2.02-1.18-3.16-.95-.22.04-.44.11-.65.2-.21.09-.42.19-.61.32-.19.13-.37.27-.53.43-.16.17-.31.35-.43.54-.13.19-.24.39-.33.6-.08.21-.15.43-.19.66-.05.22-.07.45-.07.68,0,.92.37,1.82,1.02,2.48.16.16.34.3.53.43.19.13.4.24.61.32.21.09.43.16.65.2.23.05.46.07.68.07.23,0,.46-.02.69-.07.22-.04.44-.11.65-.2.22-.08.42-.19.61-.32.19-.13.37-.27.53-.43.65-.66,1.03-1.56,1.03-2.48,0-.23-.03-.46-.07-.68-.05-.23-.11-.45-.2-.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.17,72.73c-.13-.19-.28-.37-.44-.53-.16-.17-.34-.31-.53-.44-.19-.13-.39-.23-.6-.32-.22-.09-.44-.16-.66-.2-1.14-.23-2.35.14-3.16.96-.65.65-1.02,1.55-1.02,2.47,0,.23.02.46.07.68.04.23.11.45.19.66.09.21.2.41.33.6.12.2.27.37.43.54.65.65,1.55,1.02,2.48,1.02.22,0,.45-.02.68-.07.22-.04.44-.11.66-.2.21-.08.41-.19.6-.32.19-.13.37-.27.53-.43.16-.17.31-.34.44-.54.12-.19.23-.39.32-.6.09-.21.15-.43.2-.66.04-.22.07-.45.07-.68s-.03-.46-.07-.68c-.05-.23-.11-.45-.2-.66-.09-.21-.2-.41-.32-.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.7,76.61c.12.2.27.37.43.54.65.65,1.56,1.02,2.48,1.02s1.82-.37,2.47-1.02c.65-.66,1.03-1.56,1.03-2.48,0-.23-.03-.46-.07-.68-.05-.23-.11-.45-.2-.66-.09-.21-.2-.41-.32-.6-.13-.19-.28-.37-.44-.53-1.3-1.31-3.65-1.31-4.95,0-.65.64-1.02,1.55-1.02,2.47,0,.23.02.46.07.69.04.22.11.44.2.65.08.21.19.41.32.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.61,96.92h12.54c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5h-12.54c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.84,93.42c0,1.93,1.57,3.5,3.5,3.5h12.87c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5h-12.87c-1.93,0-3.5,1.57-3.5,3.5Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M100,15.22c.92,0,1.82-.37,2.47-1.03.17-.16.31-.34.44-.53s.23-.39.32-.6c.09-.21.16-.43.2-.66.05-.22.07-.45.07-.68s-.02-.46-.07-.69c-.04-.22-.11-.44-.2-.65s-.19-.41-.32-.6c-.13-.2-.27-.37-.44-.54-.16-.16-.34-.3-.53-.43-.19-.13-.39-.24-.6-.32-.21-.09-.43-.16-.66-.2-.45-.09-.91-.09-1.36,0-.23.04-.45.11-.66.2-.21.08-.41.19-.6.32-.19.13-.37.27-.53.43-.17.17-.31.34-.44.54-.13.19-.23.39-.32.6-.09.21-.16.43-.2.65-.05.23-.07.46-.07.69,0,.92.37,1.82,1.03,2.47.65.66,1.55,1.03,2.47,1.03Z"
  })));
};
export default SvgMonitoring01;